import React from 'react'
import PropTypes from 'prop-types'
import { Button } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import CloseIcon from '@material-ui/icons/Close'

const useStyles = makeStyles((theme) => ({
    btnClose: {
        background: 'transparent',
        color: '#fff',
        border: 'none',
        fontWeight: 500,
        textTransform: 'none',
        boxShadow: 'none',
        marginLeft: theme.spacing(1),
        display: 'inline-flex',
        alignItems: 'center',
        padding: '6px 16px',
        minWidth: 0,
        '&:hover': {
            background: 'rgba(255,255,255,0.08)',
            color: '#fff',
            border: 'none'
        }
    },
    text: {
        display: 'inline-block',
        verticalAlign: 'middle',
        lineHeight: 1,
        fontSize: 16
    },
    icon: {
        fontSize: 22,
        marginLeft: 8,
        verticalAlign: 'middle',
        display: 'inline-flex',
        alignItems: 'center'
    }
}))

const ButtonClosed = ({ title, onCloseClick, className, isSaving, showText }) => {
    const classes = useStyles()
    return (
        <Button
            variant="text"
            disabled={isSaving}
            className={`${classes.btnClose} ${className || ''}`}
            onClick={onCloseClick}
        >
            {showText ? <span className={classes.text}>{title || 'Close'}</span> : null}
            <CloseIcon className={classes.icon} />
        </Button>
    )
}

ButtonClosed.propTypes = {
    onCloseClick: PropTypes.func.isRequired,
    isSaving: PropTypes.bool,
    title: PropTypes.string,
    className: PropTypes.string,
    showText: PropTypes.bool
}

ButtonClosed.defaultProps = {
    isSaving: false,
    title: 'Close',
    className: '',
    showText: true
}

export default ButtonClosed